module.exports = __webpack_public_path__ + "img/sub-nav-links-hyundai.803c5eba.png";